var Locs = [
    {
        lat: -38.232211,
        lon: 145.051997,
        title: 'Australia',
        html: [
        	'<h3>Australia</h3>',
        	'<p>Mr Gary Morris</p>',
			'<p>Head Office: 8 Fuji Crescent, Mornington, Australia</p>',
  			'<p>Supplies: Australia, New Zealand, Indonesia &amp; Pac Islandsnds</p>',
 			'<p>Phone: + 1300 707 121</p>'
   		].join(''),
        icon: 'http://www.ambientlounge.com/external/map-v2/marker.png',
        animation: google.maps.Animation.DROP
    },
    {
        lat: 51.048615,
        lon: -114.070846,
        title: 'Canada',
        html: [
			'<h3>Canada</h3>',
			'<p>Ms Shannon Buckley</p>',
			'<p>Head Office: Calgary</p>',
			'<p>Supplies: Canada</p>',
 			'<p>Phone: +1 403 861 3976</p>'
         ].join(''),
        icon: 'http://www.ambientlounge.com/external/map-v2/marker.png',
        animation: google.maps.Animation.DROP
    },
    {
        lat: 30.274085,
        lon: 120.15507,
        title: 'China',
        html: [
			'<h3>China</h3>',
			'<p>Miss Viki Cao</p>',
			'<p>Head Office: Hangzhou</p>',
			'<p>Supplies: China, Hong Kong, Taiwan &amp; Thailand.</p>',
 			'<p>Phone: +86 158 6810 7060</p>'
         ].join(''),
        icon: 'http://www.ambientlounge.com/external/map-v2/marker.png',
        animation: google.maps.Animation.DROP
    },
    {
        lat: -33.43783,
        lon: -70.650449,
        title: 'Chile',
        html: [
			'<h3>Chile</h3>',
			'<p>Mr Alexander Klimin</p>',
			'<p>Head Office: Santiago </p>',
			'<p>Supplies: Chile</p>',
 			'<p>Phone: +56 (9) 7520 5041</p>'
         ].join(''),
        icon: 'http://www.ambientlounge.com/external/map-v2/marker.png',
        animation: google.maps.Animation.DROP
    }
    ,
    {
        lat: 46.227638,
        lon: 2.213749,
        title: 'France &amp; Belgium',
        html: [
			'<h3>France &amp; Belgium</h3>',
			'<p>New Distribution Partner Wanted!</p>',
            '<p>Languages: French &amp; english</p>',
			'<p>Supplies: France &amp; Belgium</p>'
          ].join(''),
        icon: 'http://www.ambientlounge.com/external/map-v2/marker.png',
        animation: google.maps.Animation.DROP
    }
    ,
    {
        lat: 51.165691,
        lon: 10.451526,
        title: 'Germany, Austria &amp; Switzerland',
        html: [
			'<h3>Germany, Austria &amp; Switzerland</h3>',
			'<p>Mr Curt Hurlimann</p>',
            '<p>Languages: German &amp; English</p>',
			'<p>Supplies: Germany, Australia, Switzerland & Holland</p>'
          ].join(''),
        icon: 'http://www.ambientlounge.com/external/map-v2/marker.png',
        animation: google.maps.Animation.DROP
    }
    ,
    {
        lat: 22.396428,
        lon: 114.109497,
        title: 'Hong Kong',
        html: [
			'<h3>Hong Kong</h3>',
			'<p>Mr Jett Cao</p>',
			'<p>Supplies: Hong Kong</p>',
 			'<p>Phone: +86 137 3551 7693</p>'
         ].join(''),
        icon: 'http://www.ambientlounge.com/external/map-v2/marker.png',
        animation: google.maps.Animation.DROP
    }
    ,
    {
        lat: 53.41291,
        lon: -8.24389,
        title: 'Ireland',
        html: [
			'<h3>Ireland</h3>',
			'<p>Miss Laarni Otero</p>',
			'<p>All Inquiries to <a href="mailto:info@ambientlounge.ie">info@ambientlounge.ie</a></p>'
         ].join(''),
        icon: 'http://www.ambientlounge.com/external/map-v2/marker.png',
        animation: google.maps.Animation.DROP
    }
    ,
    {
        lat: 41.87194,
        lon: 12.56738,
        title: 'Italy',
        html: [
            '<h3>Italy</h3>',
            '<p>New Distribution Partner Wanted!</p>',
            '<p>All Inquiries to <a href="mailto:info@ambientlounge.com">info@ambientlounge.com</a></p>',
             '<p>Italian stock can be supplied from other territories</p>'
        ].join(''),
        icon: 'http://www.ambientlounge.com/external/map-v2/marker.png',
        animation: google.maps.Animation.DROP
    }
    ,
    {
        lat: 37.566535,
        lon: 126.977969,
        title: 'Korea',
        html: [
			'<h3>Korea:</h3>',
			'<p>Mr Jason Yang</p>',
			'<p>Head Office: Seoul, Seoul Korea</p>',
			'<p>Supplies: Korea</p>',
			'<p>Phone: +82 10 9053 5403</p>',
         ].join(''),
        icon: 'http://www.ambientlounge.com/external/map-v2/marker.png',
        animation: google.maps.Animation.DROP
    }
    ,
    {
        lat: 35.664035,
        lon: 139.698212,
        title: 'Japan',
        html: [
            '<h3>Japan</h3>',
            '<p>Mr Andrew Wallmueller &amp; Mr Todd Raikes</p>',
            '<p>Head Office: Shibuya, Tokyo</p>',
            '<p>Supplies: Japan</p>',
            '<p>Phone: +81 050 5534 3100</p>',
             '<p><span style="color:#fff">Email:</span> <a href="todd@ambientlounge.co.jp" title="Email Todd Raikes">todd@ambientlounge.co.jp</a></p>',
        ].join(''),
        icon: 'http://www.ambientlounge.com/external/map-v2/marker.png',
        animation: google.maps.Animation.DROP
    }
    ,
    {
        lat: 23.424076,
        lon: 53.847818,
        title: 'Middle East',
        html: [
			'<h3>Middle East</h3>',
			'<p>Previous Distributor: Ms Nouf Al-Mahlood</p>',
			'<p>Distributor Wanted: U.A.E, Saudi Arabia, Bahrain, Oman, Qatar, Kuwait &amp; Egypt</p>'
         ].join(''),
        icon: 'http://www.ambientlounge.com/external/map-v2/marker.png',
        animation: google.maps.Animation.DROP
    }
    ,
    {
        lat: -40.900557,
        lon: 174.885971,
        title: 'New Zealand',
        html: [
			'<h3>New Zealand</h3>',
			'<p>Ms Marguerite Perkins</p>',
			'<p>Supplies: New Zealand</p>'
         ].join(''),
        icon: 'http://www.ambientlounge.com/external/map-v2/marker.png',
        animation: google.maps.Animation.DROP
    }
    ,
    {
        lat: 18.220833,
        lon: -66.590149,
        title: 'Puerto Rico &amp; Carribean',
        html: [
			'<h3>Puerto Rico &amp; Carribean</h3>',
			'<p>Previous distributors were not nice people!</p>',
			'<p>Distribution opportunity awaits.</p>',
			'<p><a href="http://www.ambientlounge.com" target="_blank" title="Ambient Lounge: Puerto Rico &amp; Carribean">www.ambientlounge.com</a></p>',
        ].join(''),
        icon: 'http://www.ambientlounge.com/external/map-v2/marker.png',
        animation: google.maps.Animation.DROP
    }
    ,
    {
        lat: 55.755826,
        lon: 37.6173,
        title: 'Russia &amp; CIS',
        html: [
			'<h3>Russia &amp; CIS</h3>',
			'<p>Mr Borodachev Mikhail</p>',
            '<p>Head Office: Moscow</p>',
			'<p>Supplies: Russia, CIS &amp; Baltics</p>',
             '<p>Phone: +7 (499) 553-06-70</p>',
         ].join(''),
        icon: 'http://www.ambientlounge.com/external/map-v2/marker.png',
        animation: google.maps.Animation.DROP
    }
    ,
    {
        lat: 62.278648,
        lon: 12.340171,
        title: 'Scandanavia',
        html: [
			'<h3>Scandanavia</h3>',
			'<p>Previous distributor: Mr Lasse Jensen</p>',
          ].join(''),
        icon: 'http://www.ambientlounge.com/external/map-v2/marker.png',
        animation: google.maps.Animation.DROP
    }
    ,
    {
        lat: 1.352083,
        lon: 103.819836,
        title: 'Singapore &amp; Central Asia',
        html: [
			'<h3>Singapore &amp; Central Asia</h3>',
			'<p>Mr Chin Leng Yao</p>',
			'<p>Head Office: Singapore</p>',
			'<p>Supplies: Singapore, Malaysia, Thailand, Philippines, Hong Kong, Laos, Cambodia &amp; Vietnam</p>',
 			'<p>Phone: +65 9385 7052</p>'
         ].join(''),
        icon: 'http://www.ambientlounge.com/external/map-v2/marker.png',
        animation: google.maps.Animation.DROP
    }
    ,
    {
        lat: 40.463667,
        lon: -3.74922,
        title: 'Spain &amp; Portugal',
        html: [
			'<h3>Spain &amp; Portugal</h3>',
			'<p>Contact: Ms Mariona Diaz</p>',
			'<p>Previous distributor: Mr Jose Luis Cabello</p>',
			'<p>All Inquiries to <a href="mailto:mariona@ambientlounge.com">mariona@ambientlounge.com</a></p>',
 			'<p>Spanish stock can be supplied from other territories</p>'
        ].join(''),
        icon: 'http://www.ambientlounge.com/external/map-v2/marker.png',
        animation: google.maps.Animation.DROP
    }
    ,
    {
        lat: -30.559482,
        lon: 22.937506,
        title: 'South Africa',
        html: [
			'<h3>South Africa</h3>',
			'<p>New Distributor Wanted!</p>',
			'<p>Previous distributor: Mr Darren Zidel</p>',
			'<p>All Inquiries to <a href="mailto:info@ambientlounge.com">info@ambientlounge.com</a></p>',
 			'<p>South African stock can be supplied from other territories</p>'
        ].join(''),
        icon: 'http://www.ambientlounge.com/external/map-v2/marker.png',
        animation: google.maps.Animation.DROP
    }
    ,
    {
        lat: 40.712784,
        lon: -74.005941,
        title: 'USA',
        html: [
			'<h3>USA</h3>',
			'<p>Mr Gene Hollander</p>',
            '<p>Head Office: New York</p>',
			'<p>Supplies: USA </p>',
 			'<p>Phone: +1 401 218 2339</p>'
         ].join(''),
        icon: 'http://www.ambientlounge.com/external/map-v2/marker.png',
        animation: google.maps.Animation.DROP
    }
    ,
    {
        lat: 52.375599,
        lon: -1.208496,
        title: 'UK',
        html: [
			'<h3>UK</h3>',
			'<p>Miss Sarah Kirby</p>',
			'<p>Supplies: England, Scotland &amp; Wales</p>',
 			'<p>Phone: +44 (0)844 129 1112</p>'
         ].join(''),
        icon: 'http://www.ambientlounge.com/external/map-v2/marker.png',
        animation: google.maps.Animation.DROP
    }
];